import { render, staticRenderFns } from "./DashboardVendas.vue?vue&type=template&id=32e235fe&scoped=true"
import script from "./DashboardVendas.vue?vue&type=script&lang=js"
export * from "./DashboardVendas.vue?vue&type=script&lang=js"
import style0 from "./DashboardVendas.vue?vue&type=style&index=0&id=32e235fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e235fe",
  null
  
)

export default component.exports